module.exports = __webpack_public_path__ + "img/一体化平台底盘.a9abc884.png";